import queryString from "query-string";

export function parse(input) {
    return queryString.parse(input);
}

export function stringify(queryParams) {
    return queryString.stringify(queryParams);
}
